import "./Contatti.scss";

export const Contatti = () => (
  <svg id="uuid-8637b3d0-f91f-4101-a7cb-0cd2184a6496_contatti" viewBox="0 0 39.61 39.61" className="contattiIcon">
    <defs>
      <linearGradient
        id="uuid-eada9e82-86dc-44d4-a75a-4a5f761f8f2c_contatti"
        x1="3341.89"
        y1="-4489.54"
        x2="3389.87"
        y2="-4489.54"
        gradientTransform="translate(5572.21 -772.57) rotate(-135)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#95d0e5" />
        <stop offset="1" stopColor="#009ee3" />
      </linearGradient>
    </defs>
    <g id="uuid-4e14d024-fd2b-4375-a44b-a1e1ad577cb3_contatti">
      <path
        className="uuid-f6d33bd9-f158-4195-b581-9a0416fa0292"
        d="m11.01,28.17c.07.07.16.13.24.19.06.08.12.16.19.24,1.81,1.81,17.89,15.61,24.08,9.42,1.78-1.78,3.01-3.54,3.77-4.8.61-1.02.34-2.33-.63-3.02l-6.76-4.87c-1.01-.72-2.41-.51-3.15.48-.99,1.32-2.25,3.03-2.74,3.84-.86,1.43-6.47-1.33-10.56-5.42-.01,0-.03,0-.04-.01,0-.01,0-.03-.01-.04-4.09-4.09-6.85-9.71-5.42-10.56.81-.49,2.52-1.75,3.84-2.74.99-.75,1.2-2.15.48-3.15L9.41.95C8.72-.01,7.4-.29,6.39.33c-1.26.76-3.02,1.99-4.8,3.77-6.19,6.19,7.61,22.27,9.42,24.08Z"
      />
    </g>
  </svg>
);
